import React from "react"
import propTypes from "prop-types"

const Item = ({ children }) => {
  return <li className="info-dashboard_item">{children}</li>
}

Item.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Item
